import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'

export default function NexusZoneTypesBasicInfoComponent({
  handleInnerFormChange, selectedNexusZones, NexusZoneClassification, NexusZoneRank, NexusNodeType,LifeCycleStatus
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',
                )
              }}
              type="text"
              value={selectedNexusZones?.Name}
            />
            <InputContainer
              label="Code"
              name="Code"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Code',
                )
              }}
              type="text"
              value={selectedNexusZones?.Code}
            />
            <InputContainer
              label="SLANote"
              name="SLANote"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SLANote',
                )
              }}
              type="text"
              value={selectedNexusZones?.SLANote}
            />
            <InputContainer
              label="Pincodes"
              name="Pincodes"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Pincodes',
                )
              }}
              type="text"
              value={selectedNexusZones?.Pincodes}
            />
            <InputContainer
              label="Nexus Zone Classification"
              labelField="Text"
              list={NexusZoneClassification}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'NodeTypeId'

                );
              }}
              optionName='Choose Zone Classification'
              type="select"
              value={selectedNexusZones?.NexusZoneClassificationId}
              valueField="Value"
            />
            <InputContainer
              label="LifeCycleStatus"
              labelField="Text"
              list={LifeCycleStatus}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LifeCycleStatusId'

                );
              }}
              optionName='Choose Zone Classification'
              type="select"
              value={selectedNexusZones?.LifeCycleStatusId}
              valueField="Value"
            />
            <InputContainer
              label=" Zone Rank"
              labelField="Text"
              list={NexusZoneRank}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ZoneRankId'

                );
              }}
              optionName='Choose Nexus Zone'
              type="select"
              value={selectedNexusZones?.ZoneRankId}
              valueField="Value"
            />
             <InputContainer
              label="Zone Type"
              labelField="Text"
              list={NexusNodeType}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ZoneTypeId'

                );
              }}
              optionName='Choose Node Type'
              type="select"
              value={selectedNexusZones?.ZoneTypeId}
              valueField="Value"
            />
            <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Description',
                )
              }}
              type="text"
              value={selectedNexusZones?.Description}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}